const browseKeys = new Set(['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown']);

function openSelected(select) {
    const url = select.value;
    if (url && url !== window.location.pathname) {
        window.location.href = url;
    }
}

document.querySelectorAll('[data-property-overview-change]').forEach((select) => {
    let browsing = false;

    select.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            openSelected(select);
            return;
        }
        browsing = browseKeys.has(event.key) || event.key.length === 1;
    });

    select.addEventListener('pointerdown', () => {
        browsing = false;
    });

    select.addEventListener('change', () => {
        if (browsing) {
            browsing = false;
            return;
        }
        openSelected(select);
    });
});
